import { css } from '@emotion/react';
import { ReactElement } from 'react';

import { useSDK } from '../../../app';
import { styled } from '../../../styled';
import type { Theme } from '../../../theme/interface/detailed';
import { isMobile } from '../../../utils/isMobile';
import { useSanitize } from '../../../utils/useSanitize';

type Interface = { className: string };

const Component = ({ className }: Interface): ReactElement => {
	const { welcomeDataStore } = useSDK();
	const headerHtml = useSanitize(welcomeDataStore.data?.showcase.welcomeText || '') || undefined;

	return <div dangerouslySetInnerHTML={headerHtml} className={className} />;
};

const PrechatHeader = styled(Component)(
	({
		theme: {
			prechat: {
				header: { prechatHeader },
			},
		},
	}: {
		theme: Theme;
	}) => prechatHeader,
	css`
		display: flex;
		flex-direction: column;
		grid-gap: 4px;
		position: relative;

		& > div {
			${isMobile ? 'padding: 0 20px' : ''}
		}

		& svg {
			cursor: pointer;
		}
	`
);

export { PrechatHeader };
